import axios from "axios";
import { defineStore } from "pinia";

export const useArticleStore = defineStore("article-verifier", {
  state: () => ({
    apiUrl: process.env.VUE_APP_API_URL,
    articles: [],
    article: {},
    response: {
      status: null,
      message: null,
      list: [],
    },
    formAction: {
      action: "",
      form_title: "",
      form_button: "",
    },
    current: 1,
    perpage: 25,
    totalData: 0,
    sort: "",
    titleQuery: "",
    status: "",
    category_ids: "",
    tag_ids: "",
  }),

  actions: {
    openForm(newAction) {
      this.formAction.action = newAction;
    },

    async changePage(newPage) {
      this.current = newPage;
    },

    async getArticles() {
      const params = new URLSearchParams({
        current: this.current,
        per_page: this.perpage,
      });

      if (this.title) params.append("title", this.title);
      if (this.sort !== "") params.append("sort", this.sort);
      if (this.status) params.append("status", this.status);
      if (this.category_ids) params.append("category_ids", this.category_ids);
      if (this.tag_ids) params.append("tag_ids", this.tag_ids);

      try {
        const res = await axios.get(`${this.apiUrl}/api/v1/articles`, {
          params,
        });

        this.articles = res.data.data.list;
        this.totalData = res.data.data.meta.total;
      } catch (error) {
        this.response = {
          status: error.response?.status,
          message: error.message,
          list: error.response.data.errors,
        };
      }
    },

    async getTrashedArticle() {
      try {
        const res = await axios.get(`${this.apiUrl}/api/v1/articles/trashed`);

        this.articles = res.data.data.list;
      } catch (error) {
        this.response = {
          status: error.response?.status,
          message: error.message,
          list: error.response.data.errors,
        };
      }
    },

    async getArticleById(id) {
      try {
        const res = await axios.get(
          `${this.apiUrl}/api/v1/articles-by-id/${id}`
        );

        this.article = res.data.data;
      } catch (error) {
        this.response = {
          status: error.response?.status,
          message: error.message,
          list: error.response.data.errors,
        };
      }
    },

    async getArticleBySlug(slug) {
      try {
        const res = await axios.get(`${this.apiUrl}/api/v1/articles/${slug}`);

        this.article = res.data.data;
      } catch (error) {
        this.response = {
          status: error.response?.status,
          message: error.message,
          list: error.response.data.errors,
        };
      }
    },

    async addArticle(data) {
      try {
        const res = await axios.post(`${this.apiUrl}/api/v1/articles`, data);

        this.response = {
          status: res.status,
          message: res.data.message,
        };
      } catch (error) {
        this.response = {
          status: error.response?.status,
          message: error.message,
          list: error.response.data.errors,
        };
      }
    },

    async updateArticle(data) {
      try {
        const res = await axios.put(`${this.apiUrl}/api/v1/articles`, data);

        this.response = {
          status: res.status,
          message: res.data.message,
        };
      } catch (error) {
        this.response = {
          status: error.response?.status,
          message: error.message,
          list: error.response.data.errors,
        };
      }
    },

    async deleteArticle(id) {
      try {
        const res = await axios.delete(`${this.apiUrl}/api/v1/articles/${id}`);

        this.response = {
          status: res.status,
          message: res.data.message,
        };
      } catch (error) {
        this.response = {
          status: error.response?.status,
          message: error.message,
          list: error.response.data.errors,
        };
      }
    },

    async forceDeleteArticle(id) {
      try {
        const res = await axios.delete(`${this.apiUrl}/api/v1/articles/force/${id}`);

        this.response = {
          status: res.status,
          message: res.data.message,
        };
      } catch (error) {
        this.response = {
          status: error.response?.status,
          message: error.message,
          list: error.response.data.errors,
        };
      }
    },

    async restoreArticles(id) {
      try {
        const res = await axios.post(`${this.apiUrl}/api/v1/articles/restore/${id}`);

        this.response = {
          status: res.status,
          message: res.data.message,
        };

      } catch (error) {
        this.response = {
          status: error.response?.status,
          message: error.message,
          list: error.response.data.errors,
        };
      }
    },
  },
});
